import script from "./Controls.vue?vue&type=script&setup=true&lang=js"
export * from "./Controls.vue?vue&type=script&setup=true&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=63f34521&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f34521"]])

export default __exports__